import type React from 'react';

import { CreateSourceGroupButton } from '@vlabs/monokit/features/create-source-group';
import { PageHeader, usePageContext } from '@vlabs/monokit/shared/ui/page';
import { generatePath, useHistory } from 'react-router-dom';

import { useSourceListPageTranslation } from './i18n';
import { routes } from '../../app/routes';

function SourceListPageHeader(): React.JSX.Element {
  const { t } = useSourceListPageTranslation();
  const history = useHistory();
  const { buttonSize } = usePageContext();

  return (
    <PageHeader
      actions={[
        <CreateSourceGroupButton
          key="create-source-group"
          onCreateSourceGroup={(groupId) => {
            history.push(generatePath(routes.sources.groupView, { groupId }));
          }}
          size={buttonSize}
        />,
      ]}
      title={t('title')}
    />
  );
}

export { SourceListPageHeader };
